export type UiRole = 'admin' | 'teacher' | 'student' | 'parent' | 'secretariat';

export function backendRoleToUiRole(role: string): UiRole {
  switch (role) {
    case 'admin':
      return 'admin';
    case 'profesor':
      return 'teacher';
    case 'elev':
      return 'student';
    case 'parinte':
      return 'parent';
    case 'secretariat':
      return 'secretariat';
    default:
      return 'student';
  }
}
